import PickOneTreasureBonusRecord from 'integration/pickone-treasure-bonus-record';
import { DOScenes, GFCustomLayers } from 'names/do-names';
import { ShowAllMenusCommand } from 'slotworks/commands/menus/show-all-menus-command';
import ShowPromoFSafterFreespins from 'slotworks/commands/promo-free-spins/show-pfs-after-freespins';
import { StaticSymbolsCommand } from 'slotworks/commands/symbols/static-symbols-command';
import { BetBarType } from 'slotworks/components/betbar/bet-bar-component';
import Components from 'slotworks/components/components';
import canvasManager from 'slotworks/graphics/canvas/canvas-manager';
import Layers from 'slotworks/graphics/layers/layers';
import campaignsModel from 'slotworks/integration/revolver/model/campaigns-model';
import GameState from 'slotworks/model/game-state';
import FreespinRecord from 'slotworks/model/gameplay/records/freespin-record';
import SmartButton, { SmartButtonFlag } from 'slotworks/smart-button/smart-button';
import BetModel from 'slotworks/model/bets/bet-model';
import * as TweenJS from 'slotworks/utils/tween';
import GameInit from 'states/game-init';
import Point from 'slotworks/utils/geom/point';

export function showLayers(): void {
    Layers.Paylines.show();
    Layers.BetBar.show();
    Layers.SmartButton.show();
    Layers.MatrixForeground.show();
    Layers.MatrixContent.show();
    Layers.MatrixBackground.show();
    Layers.CelebrationBackground.show();
    Layers.CelebrationContent.show();
    Layers.CelebrationForeground.show();
    Layers.Banners.show();
    Layers.Background.show();
    Layers.SymbolAnimations.show();
    Layers.Custom.get(GFCustomLayers.ANTICIPATION).show();
    Layers.Custom.get(GFCustomLayers.BACKGROUND_ANIMATIONS).show();
    Layers.Custom.get(GFCustomLayers.WILD_STICKY).show();
    Layers.BetBarPopups.show();
    Layers.Header.show();
}

export function allSymbolFadeEnable() {
    for (let i = 0; i < Components.matrix.getAllSymbols().length; i++) {
        Components.matrix.getAllSymbols()[i].setSymbolFade(true);
    }
}

export function changeState(state: DOScenes) {
    switch (state) {
        case DOScenes.FREESPIN:
            Layers.SmartButton.setScene(DOScenes.FREESPIN).execute();
            SmartButton.setFlag(SmartButtonFlag.PROMPT, false);
            SmartButton.setFlag(SmartButtonFlag.BONUS, false);
            SmartButton.setFlag(SmartButtonFlag.IDLE, false);
            SmartButton.setFlag(SmartButtonFlag.FREE_SPINS, true);
            Layers.MatrixBackground.setScene(DOScenes.FREESPIN).execute();
            Layers.Background.setScene(DOScenes.FREESPIN).execute();
            Layers.Header.setScene(DOScenes.FREESPIN).execute();
            Components.banner.setMode(DOScenes.FREESPIN);
            Layers.Bonus.defaultScene().execute();
            Layers.BonusForeground.defaultScene().execute();
            Layers.BetBar.setScene(DOScenes.FREESPIN).execute();
            Components.betBar.setType(BetBarType.FREESPINS);
            Layers.Custom.get(GFCustomLayers.BACKGROUND_ANIMATIONS)
                .setScene(DOScenes.FREESPIN)
                .execute();
        //    Components.betBar.setBetOptions(BetModel.generateBetOptions());
            playBackgroundAnimation();
            break;
        case DOScenes.BONUS_TO_DEFAULT:
            SmartButton.setFlag(SmartButtonFlag.PROMPT, false);
            Layers.Bonus.defaultScene().execute();
            Layers.BonusForeground.defaultScene().execute();
            SmartButton.setFlag(SmartButtonFlag.FREE_SPINS, false);
            SmartButton.setFlag(SmartButtonFlag.PROMPT, false);
            const record = GameState.getCurrentGame().getCurrentRecord();
            const r = record.getResultsOfType(PickOneTreasureBonusRecord) as PickOneTreasureBonusRecord[];
            const bonusRecord: PickOneTreasureBonusRecord = r[0];
            Components.matrix.reset();
            Components.matrix.resetSymbolPositions();
            Components.matrix.resetSymbols();
            (GameState.getCurrentGame().getCurrentRecord() as FreespinRecord).creditsWon = bonusRecord.total_win_cash;
            (GameState.getCurrentGame().getCurrentRecord() as FreespinRecord).beenPaid = true;
            (GameState.getCurrentGame().getCurrentRecord() as FreespinRecord).results = [];
            break;
        case DOScenes.FREESPIN_TO_DEFAULT:
            SmartButton.setFlag(SmartButtonFlag.PROMPT, false);
            Layers.All.forEach(layer => layer.hide());
            Layers.Custom.get('Poster').show();
            Layers.Prompts.show();
            Layers.Background.show();
            Layers.Header.show();
            Components.banner.setMode(DOScenes.DEFAULT);
            StaticSymbolsCommand().execute();
            Components.matrix.reset();
            Components.matrix.resetSymbolPositions();
            Components.matrix.resetSymbols();
            Layers.Background.defaultScene().execute();
            Layers.Custom.get(GFCustomLayers.BACKGROUND_ANIMATIONS)
                .setScene(DOScenes.DEFAULT)
                .execute();
            Layers.MatrixBackground.defaultScene().execute();
            Layers.Header.defaultScene().execute();
            Components.betBar.destroy();
            Components.betBar.setType(BetBarType.DEFAULT);
            Components.betBar.setEnabled(true);
            Components.betBar.setBetOptions(BetModel.generateBetOptions());
            SmartButton.setFlag(SmartButtonFlag.FREE_SPINS, false);
            SmartButton.setFlag(SmartButtonFlag.PROMPT, false);
            ShowPromoFSafterFreespins();
            const freespins = campaignsModel.freespins;
            ShowAllMenusCommand();
            (GameState.getCurrentGame().getCurrentRecord() as FreespinRecord).creditsWon = GameInit.freeSpinsWin;
            (GameState.getCurrentGame().getCurrentRecord() as FreespinRecord).beenPaid = true;
            (GameState.getCurrentGame().getCurrentRecord() as FreespinRecord).isFreespinsComplete = false;
            (GameState.getCurrentGame().getCurrentRecord() as FreespinRecord).results = [];
            if (freespins?.totalWin) {
                Components.promoBetBar.setTotalWin(freespins.totalWin);
            }
            showLayers();
            playBackgroundAnimation();
            break;
    }
}

export function cloudLoop(tween: TweenJS.Tween, object: PIXI.Sprite, from: number, to: number, duration: number) {
    object.position.x = from;
    tween
        .to({ x: to }, duration)
        .onComplete(() => {
            cloudLoop(tween, object, from, to, duration);
        })
        .easing(TweenJS.Easing.Linear.None)
        .start();
}

export function playBackgroundAnimation() {
    for (let i = 0; i < GameInit.cloudAnimations?.length; i++) {
        TweenJS.removeAll(GameInit.cloudAnimations[i]);
    }
    GameInit.cloudAnimations = [];
    const cloud1 = Layers.Custom.get(GFCustomLayers.BACKGROUND_ANIMATIONS).getSprite('clouds_1');
    const cloud2 = Layers.Custom.get(GFCustomLayers.BACKGROUND_ANIMATIONS).getSprite('clouds_2');
    GameInit.cloudAnimations.push(new TweenJS.Tween(cloud1));
    GameInit.cloudAnimations.push(new TweenJS.Tween(cloud2));
    cloudLoop(GameInit.cloudAnimations[0], cloud1, 500, 6500, 50000);
    cloudLoop(GameInit.cloudAnimations[1], cloud2, -2500, 4500, 50000);
}

export function setFullScreenCelebrationFilter() {
    const filter = Layers.CelebrationBackground.getSprite('filter');
    if (!filter) return;

    filter.width = canvasManager.stageWidth + 2 * canvasManager.stageOffsetX;
    filter.height = canvasManager.stageHeight + 2 * canvasManager.stageOffsetY;

    let pos = Layers.CelebrationBackground.globalToLocal(new Point(-canvasManager.stageOffsetX, -canvasManager.stageOffsetY));
    filter.position.set(pos.x, pos.y);
}



// WEBPACK FOOTER //
// ./src/components/ui-helper.ts